import { api_GET, api_POST, api_PUT, api_GET_Unauthorize } from './_api';

const documento_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListDocumentosCategoria: (categoria) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetListDocumentosCategoria/${categoria}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Documento/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Documento/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetCategoriasGerador: (documentoId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetCategoriasGerador/${documentoId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    SalvarCategoriasGerador: (documentoId, payload) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Documento/SalvarCategoriasGerador/${documentoId}`, payload)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetListPorCategoriaGerador: (categoriaId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Documento/GetListPorCategoriaGerador/${categoriaId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },

    GetListPorCategoriaNome: (categoria) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Documento/GetListPorCategoriaNome/${categoria}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    }
}

export default documento_api;